<div class="container" *ngIf="country==='AU'">
  <!-- AU - start -->
  <div class="tc-wrapper">
    <div class="">
      <div class="">
        <h1>Terms and conditions</h1>
        <h2>Everyday Rewards Plus Card - Australian team members<br> &nbsp;</h2>
      </div>
    </div>
    <div class="">
      <div class="">
        <p><span class="bold">It is your responsibility to ensure that your Everyday Rewards Plus Card is used in line with these
          Everyday Rewards Plus Card Terms and Conditions as well as the Everyday Rewards Program Terms and
          Conditions which can be found at </span> <a href="https://www.woolworthsrewards.com.au/terms.html"
                                                  target="_blank">everdayrewards.com.au/terms</a>.
        </p>
        <p>It is important that you read these terms and conditions. In addition, there are some specific terms we
          wanted to make you aware of. These are set out below.&nbsp;</p>
        <p>These terms and conditions apply in addition to the Everyday Rewards Terms and Conditions.</p>
        <p>It is important that you read these terms and conditions and the Everyday Rewards Terms and Conditions
          together.</p>
        <p>We can also, at any time without notice:</p>
        <ul>
          <li>
            <p>decline to issue, withdraw or cancel your Everyday Rewards Plus Card or offers;</p>
          </li>
          <li>
            <p>reverse any related offer benefits; and</p>
          </li>
          <li>
            <p>terminate or suspend your Everyday Rewards Plus Card account.&nbsp;</p>
          </li>
        </ul>
        <p>We may also change or suspend these terms and conditions or the Everyday Rewards Plus Card program at any
          time. However, if these changes are substantive, we’ll give you notice ahead of time.&nbsp;</p>
        <p>These Everyday Rewards Plus Card Terms and Conditions apply to all Everyday Rewards Plus cardholders
          (whether you are the primary or the secondary cardholder) in addition to the Everyday Rewards program Terms
          and Conditions. To the extent of any inconsistency, these Everyday Rewards Plus Card Terms and Conditions
          will take precedence.</p>
        <p>If you are an existing Everyday Rewards member, you are able to link your existing Everyday Rewards
          membership to your Everyday Rewards Plus Card account and your existing Everyday Rewards points balance will
          be reflected in your new Everyday Rewards Plus Card account.</p>
        <p>If you do not wish to link your existing Everyday Rewards membership to your Everyday Rewards Plus Card
          account, you will need to provide a separate email address (which is different from the email address you
          are using for your existing Everyday Rewards account) in order to activate your Everyday Rewards Plus Card
          and open a new Everyday Rewards account.</p>
        <p>By activating your Everyday Rewards Plus Card you will, unless you are already an Everyday Rewards member
          and you link your existing Everyday Rewards account to your Everyday Rewards Plus Card account, also be
          enrolled in the Everyday Rewards program.</p>
        <p>There are two supported versions of the digital Everyday Rewards Plus Card: Apple Wallet and Google Pay.
          Use of any other card storage apps, such as StoCard, is not permitted.</p>
        <p>You can also download the Everyday Rewards app and load your Everyday Rewards Plus Card. This will allow
          you to get in app access to your offers and boosters, including getting access to app exclusive offers and
          boosters. If you have your 13-digit Everyday Rewards Card number, you can use the digital card in the
          Everyday Rewards App.</p>
        <p class="bold">Important things to note:</p>
      </div>
    </div>
    <div class="">
      <div class="">
        <h3>Who is eligible for a primary Everyday Rewards Plus Card?</h3>
        <ul>
          <li>If you are a full-time, part-time or casual team member (employee) of Woolworths Group Limited or any of
            its majority owned subsidiaries (collectively, Woolworths Group), you are eligible to apply for a primary
            Everyday Rewards Plus Card.
          </li>
          <li>
            <p>If you are a full-time, part-time or casual team member (employee) of Endeavour Group Limited or any of
              its majority owned subsidiaries (collectively, Endeavour Group),&nbsp; you are eligible to apply for a
              primary Everyday Rewards Plus Card.</p>
          </li>
          <li>
            <p>Certain employees of particular Woolworths Group partner businesses may also be eligible to apply for a
              primary Everyday Rewards Plus Card, as notified to those employees by Woolworths Group or their employer
              from time to time.</p>
          </li>
          <li>
            <p>Endeavour Group and Woolworths Group partner businesses whose employees are eligible for a primary
              Everyday Rewards Plus Card are referred to in these terms and conditions as “Eligible Partners”.</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="">
      <div class="">
        <h3>If I am a primary Everyday Rewards Plus cardholder, can I apply for a secondary Everyday Rewards Plus
          Card?</h3>
        <ul>
          <li>
            <p>If you are a full-time or part-time team member (employee) of Woolworths Group or Endeavour Group, you
              can apply for a secondary Everyday Rewards Plus Card. You can nominate as your secondary Everyday
              Rewards Plus cardholder one member of your (the primary cardholder's) immediate family who must live at
              the same address as the primary Everyday Rewards Plus cardholder e.g. a spouse, de facto partner,
              parent, child or sibling. If your secondary cardholder is under the age of 18, you must first obtain
              their parent or guardian’s consent to join.&nbsp;</p>
          </li>
          <li>
            <p>If you are a primary Everyday Rewards Plus cardholder who is eligible to apply for a secondary Everyday
              Rewards Plus Card, you agree to only apply for and activate the secondary Everyday Rewards Plus Card for
              your secondary cardholder with that person’s consent and only after they have agreed to these Terms and
              Conditions, and you have advised them that their personal information will be disclosed to Woolworths
              Group Limited and treated in accordance with <a href="https://www.woolworthsgroup.com.au/privacy"
                                                              target="_blank">Woolworths’ Group Privacy Policy</a>.&nbsp;
            </p>
          </li>
          <li>
            <p>The eligibility of primary Everyday Rewards Plus cardholders who are employees of Eligible Partners
              other than Endeavour Group, to apply for a secondary Everyday Rewards Plus Card will be notified to
              those employees by Woolworths Group or their employer from time to time.</p>
          </li>
          <li>
            <p>Casual team members (employees), whether of Woolworths Group, Endeavour Group or any other Eligible
              Partner, are not eligible for a secondary Everyday Rewards Plus Card.&nbsp;</p>
          </li>
          <li>
            <p>The secondary Everyday Rewards Plus Card will be issued in the nominated family member's name. The
              secondary cardholder will cease to be eligible if they no longer reside at the same primary address as
              the primary Everyday Rewards Plus cardholder.</p>
          </li>
          <li>
            <p>Each primary and secondary cardholder will have a separate Everyday Rewards account and card relating
              to their individual Everyday Rewards Plus Card.</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="">
      <div class="">
        <h3>Only you may use your Everyday Rewards Plus Card:</h3>
        <ul>
          <li>
            <p>Primary and secondary cardholders are the only individuals who are allowed to use or otherwise receive
              the offers associated with the Everyday Rewards Plus Card program. Everyday Rewards Plus Cards can only
              be used by the person whose name appears on the card.</p>
          </li>
          <li>
            <p>The Everyday Rewards Plus Card account and card must not be used to obtain a discount or other benefit
              for anyone other than the cardholder, and may not be used to purchase goods for resale. Proof of
              identification may be requested at the point of sale. If identification is not provided, the discount
              may not be applied.</p>
          </li>
        </ul>
        <ul>
          <li>
            <p>Cards should not be “shared” either in a physical, copied or digital format, i.e. cardholders should
              not allow another person to use their Everyday Rewards Plus Card. Misuse of the Everyday Rewards Plus
              Card may also result in the card being confiscated and/or one or both of the cardholders no longer being
              eligible to receive Everyday Rewards Plus Card offers. Misuse of the Everyday Rewards Plus Card may also
              result in disciplinary action being taken against the primary cardholder (i.e. the team member) by their
              employer, which may include termination of the team member’s employment. The primary and any secondary
              Everyday Rewards Plus Cards must be returned to Woolworths Group or, if directed, destroyed by the
              cardholder when the team member ends employment with Woolworths Group or the Eligible Partner.</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="">
      <div class="">
        <h3>What offers can I get as an Everyday Rewards Plus Card cardholder?</h3>
        <p>The Everyday Rewards Plus Card entitles the cardholder to the below offers:</p>
        <ul>
          <li>
            <p>5% off at Woolworths Supermarkets and Woolworths Metro (excluding Ampol Woolworths Metro), with an
              extra 5% off selected Woolworths Food Company brands (in store only). For more information&nbsp;on the
              Woolworths Food Company discount,&nbsp;<a
                href="https://teambenefits.woolworths.com.au/everyday-rewards-plus/woolworths-foodco-brands.html"
                target="_blank">click here</a>.</p>
          </li>
          <li>
            <p>5% off&nbsp; at BWS (excluding NT), plus an extra 5% off Pinnacle Wines (excluding NT; in-store only).
              Look for an ‘E’ on tickets and ‘bottled by Pinnacle drinks’ on the back label. Discount does not apply
              to liquor items in the Northern Territory, so as to ensure compliance with the NT Government’s minimum
              unit price for alcohol (minimum floor price). For more information regarding the Pinnacle Wine discount,
              <a href="https://teambenefits.woolworths.com.au/everyday-rewards-plus/bws-discounts.html" target="_blank">click
                here</a>.&nbsp;</p>
          </li>
          <li>
            <p>10% off at BIG W in-store and online, excluding BIG W Photos online, Apple products, gaming consoles,
              lay-bys, rainchecks, any gift cards (including iTunes), mobile recharge, travel cards, tickets, BIG W
              eBay, pre-orders, lay-by fees and BIG W products purchased from Everyday Market from Woolworths.
              Additional 10% discount at BIG W on apparel applies to&nbsp; men’s, women’s, kids’ and baby apparel,
              including swimwear, beachwear, footwear and schoolwear (total 20% discount) but excluding accessories
              (such as belts, hats, scarves, gloves, caps and ties), underwear, socks and sleepwear (standard 10%
              discount applies), and any BIG W apparel products purchased from Everyday Market from Woolworths or as
              lay-bys, pre-orders or rainchecks (no discount applies). For BIG W online only, when a product which is
              excluded from the 10% discount offer is added to the shopping cart (eg. gaming console), the 10%
              discount offer will NOT apply to the entire shopping cart, even if it includes products to which the 10%
              discount offer would otherwise apply. So that you receive the 10% discount on eligible products when
              shopping online, you will need to purchase products which are excluded from the 10% team discount offer
              in a separate online transaction from products which are eligible for the 10% discount offer.</p>
          </li>
        </ul>
        <ul>
          <li>4c per litre off the pump price on fuel purchases of up to 150 litres per transaction at participating
            Ampol or Caltex Woolworths/EG Australia fuel outlets. Discounts do not apply to purchases using an
            AmpolCard, a Country Age Pension Fuel Card or on a charge account. A list of participating Ampol locations
            and Caltex Woolworths/EG Australia locations can be found at <a
              href="http://www.woolworths.com.au/shop/storelocator" target="_blank">www.woolworths.com.au/shop/storelocator</a>.
            To find out more about the fuel savings
            offer, terms and conditions and details of participating sites, <a
              href="https://www.woolworths.com.au/shop/discover/petrol?name=petrol-offer-8&amp;cardId=4854"
              target="_blank">click here</a>.<br>
          </li>
          <li>A free ongoing subscription to Everyday Extra (valued at $59 per year).</li>
        </ul>
        <p><span class="bold">General Exclusions:</span> The Everyday Rewards Plus Card does not entitle the cardholder to discounts on
          any products sold on smoking products, gift cards (including Woolworths WISH Gift Cards, eGift cards and
          iTunes), mobile recharge, travel cards, tickets, cash outs, delivery charges, bag fees, donations, Carpet
          Care, lottery products and Pre-order Kiosks when you scan your card in-store or online at Woolworths,
          Everyday Market from Woolworths, BWS and BIG W. In addition, no discounts apply to any products sold on
          Everyday Market from Woolworths. Your Team Benefits discount offers are also not available in conjunction
          with any other discount offers, except if otherwise stated in the particular offer terms and conditions.</p>
      </div>
    </div>
    <div class="">
      <div class="">
        <h3>What communications will I receive from Everyday Rewards about the Everyday Rewards Plus Card and how can
          I opt out of Everyday Rewards Plus Card communications?</h3>
        <p>As an Everyday Rewards Plus Card cardholder you will receive:</p>
        <ul>
          <li>
            <p>communications (including marketing and promotional messages) sent to you in your capacity as an
              Everyday Rewards member. For more details about communications you receive as an Everyday Rewards
              member, please see the Everyday Rewards Terms and Conditions here:<a
                href="https://www.woolworthsrewards.com.au/terms.html">https://www.everydayrewards.com.au/terms.html</a>;
              and</p>
          </li>
          <li>
            <p>marketing and promotional messages exclusive to Everyday Rewards Plus cardholders, and which
              accordingly are sent to you in your capacity as an Everyday Rewards Plus cardholder.</p>
          </li>
        </ul>
        <p>Importantly, opting out of:</p>
        <ul>
          <li>
            <p>the Everyday Rewards Plus Offers (Boosters) preference in your Everyday Rewards account or via the
              unsubscribe facility in messages we send you will not opt you out of receiving messages from Everyday
              Rewards in relation to other Everyday Rewards preferences categories (eg. Woolworths Supermarkets); and
            </p>
          </li>
          <li>
            <p>other Everyday Rewards preferences categories (eg. Woolworths Supermarkets) will not unsubscribe you
              from Everyday Rewards Plus promotional messages (including any Everyday Rewards Plus promotional
              messages in relation to Woolworths Supermarkets).</p>
          </li>
        </ul>
        <p>There are also some messages that we must be able to send you even if you have opted-out. These include,
          for example:</p>
        <ul>
          <li>
            <p>messages relating to your Everyday Rewards or Everyday Rewards Plus Card account, such as changes to
              your account, important information relating to products and services you have purchased (like health
              and safety recall notices), forgotten passwords, updates to our Terms and Conditions and Privacy Policy;
              and</p>
          </li>
          <li>
            <p>If you are a Woolworths Group Team Member, messages we send you as your Employer, such as messages
              about Team Benefits that we send exclusively to all Woolworths Group Employees (not just Everyday
              Rewards Plus Card primary cardholders).</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="">
      <div class="">
        <h3>Can my Everyday Rewards Plus Card be cancelled or terminated?</h3>
        <p>We reserve the right at any time without notice to:</p>
        <ul>
          <li>
            <p>decline to issue, withdraw or cancel any Everyday Rewards Plus Card or offers;</p>
          </li>
          <li>
            <p>reverse any Everyday Rewards Plus Card offer benefits; and</p>
          </li>
          <li>
            <p>terminate or suspend your Everyday Rewards Plus Card account.</p>
          </li>
        </ul>
        <p>Grounds for any of the above include:</p>
        <ul>
          <li>
            <p>the termination or suspension of your Everyday Rewards account;</p>
          </li>
          <li>
            <p>if the primary cardholder’s account has been terminated (including when the primary cardholder’s
              employment with Woolworths Group, or with the Eligible Partner, ends); and</p>
          </li>
          <li>
            <p>if the primary or secondary cardholder has done anything that is contrary to these terms and
              conditions.</p>
          </li>
        </ul>
        <p>If your Everyday Rewards Plus Card account is terminated, you will no longer receive the offers associated
          with the Everyday Rewards Plus Card program. Any physical Everyday Rewards Plus Card relating to the
          terminated account or accounts must also be returned to Woolworths Group or, if directed, destroyed by the
          relevant cardholder.</p>
        <p>If your Everyday Rewards Plus Card account is terminated, you will, unless your Everyday Rewards membership
          has also separately been terminated, remain an Everyday Rewards member and the Everyday Rewards Terms and
          Conditions will continue to apply to your Everyday Rewards membership.</p>
        <p>If you cancel your Everyday Rewards membership that is linked to your Everyday Rewards Plus Card account,
          your Everyday Rewards Plus Card account will also be terminated.&nbsp;If you are a Woolworths Group Team
          Member, messages we send you as your Employer, such as messages about Team Benefits that we send exclusively
          to all Woolworths Group Employees (not just Everyday Rewards Plus Card primary cardholders).</p>
      </div>
    </div>
    <div class="">
      <div class="">
        <h3>Can these terms and conditions be changed or the Everyday Rewards Plus Card program terminated?</h3>
        <p>Yes. Woolworths Group Limited reserves the right to change or suspend these terms and conditions or to
          terminate the Everyday Rewards Plus Card program at any time.</p>
        <p>We will notify both primary and secondary cardholders of any substantive changes to these terms and
          conditions, for example, by publishing a banner notification on&nbsp;<a
            href="https://teambenefits.woolworths.com.au/team-discount-selfserve/terms-conditions-australia.html"
            target="_blank">https://teambenefits.woolworths.com.au/team-discount-selfserve/terms-conditions-australia.html</a>.
          Continuing to use your Everyday Rewards Plus Card after the effective date of the changes to these terms and
          conditions will be deemed as acceptance by you of the terms and conditions as so amended.</p>
      </div>
    </div>
    <div class="">
      <div class="">
        <h3>What happens if I leave Woolworths Group or the Eligible Partner? Will the Everyday Rewards Plus Card be
          cancelled?</h3>
        <p>Yes, if you leave the employment of Woolworths Group or Eligible Partner, your Everyday Rewards Plus Card
          and any secondary Everyday Rewards Plus Cards will be cancelled. You and the former secondary Everyday
          Rewards Plus cardholder will be issued with separate Everyday Rewards customer cards. All Everyday Rewards
          dollars and Qantas Frequent Flyer Points accumulated by you will be transferred to the Everyday Rewards
          customer cards. The Everyday Rewards team will send out the Everyday Rewards customer card to the address
          stated in your Everyday Rewards account.</p>
      </div>
    </div>
    <div class="">
      <div class="">
        <h3>How will Everyday Rewards Plus be collecting, using and disclosing my personal information?</h3>
        <p>For details about how your personal information is dealt with please see the Everyday Rewards Privacy
          Collection Notice at <a href="https://www.woolworthsrewards.com.au/privacy.html" target="_blank">everydayrewards.com.au/privacy</a>.
          If you are an Everyday Rewards
          Plus cardholder who
          is an employee of an Eligible Partner, please be aware that Woolworths Group may disclose personal
          information in relation to you and your use of your Everyday Rewards Plus Card to your employer, in the
          event that Woolworths Group has reasonable grounds to suspect misuse of your Everyday Rewards Plus Card.
          Woolworths Group will only disclose such information as is reasonably required for investigation of the
          suspected misuse.&nbsp;&nbsp;</p>
      </div>
    </div>
  </div>
  <!-- AU - end -->
  <div *ngIf="purpose === 'activation' || purpose === 'selfserve'" class="terms-checkbox">
    <mat-checkbox [checked]="termsCheck" (change)="toggleTermsCheck($event.checked)">
      Yes, I have read and accept the Terms and Conditions.
    </mat-checkbox>
  </div>
  <div class="button-container" *ngIf="purpose === 'activation'">
    <button mat-raised-button color="accent" [disabled]="!termsCheck" (click)="termsClick.emit()">
      Continue
    </button>
  </div>
  <div class="button-container" *ngIf="purpose === 'selfserve'">
    <button mat-raised-button (click)="termsClick.emit('cancel')">
      Cancel
    </button>
    <button mat-raised-button color="accent" [disabled]="!termsCheck" (click)="termsClick.emit('continue')">
      Continue
    </button>
  </div>
</div>
<div class="container" *ngIf="country==='NZ'">
  <!-- NZ - start -->
  <div class="tc-wrapper">
    <div class="">
      <div class="">
        <h1>Self Serve Portal Terms & Conditions for Woolworths New Zealand Team Members</h1>
        <h2>Everyday Rewards Plus Card Terms & Conditions</h2>
      </div>
    </div>

    <div>
      <div>
        <p><span class="bold">It is your responsibility to ensure that your Everyday Rewards Plus Card is used in line with these Everyday
          Rewards Plus Card Terms & Conditions as well as the Everyday Rewards Program Terms & Conditions which can be
          found at </span> <a href="https://www.everydayrewards.co.nz/terms-and-conditions" target="_blank">everydayrewards.co.nz/terms-and-conditions</a>.
        </p>
        <p>These terms and conditions are important and you should read them fully.</p>
        <p>However, there are some specific terms of which we wanted to make you aware. These are set out below.</p>
        <p>These terms and conditions include our Everyday Rewards Terms and Conditions. We recommend that you refer to
          our Everyday Rewards Terms and Conditions for further information about important terms in those terms and
          conditions of which you should be aware.</p>
        <p>We can also, at any time without notice:</p>
        <ul>
          <li>decline to issue, withdraw or cancel your Everyday Rewards Plus Cards or offers;</li>
          <li>reverse any related offer benefits; and</li>
          <li>terminate or suspend your Everyday Rewards Plus Card account.</li>
        </ul>
        <p>We may also change or suspend these terms and conditions or the Everyday Rewards Plus Card program at any
          time. However, if these changes are substantive, we’ll give you notice ahead of time.</p>
      </div>
    </div>

    <div>
      <div>
        <p>These Everyday Rewards Plus Card Terms & Conditions apply to all Everyday Rewards Plus cardholders (whether
          you are the primary or the secondary cardholder) in addition to the Everyday Rewards Program Terms &
          Conditions. To the extent of any inconsistency between the two sets of terms and conditions, these Everyday
          Rewards Plus Card Terms & Conditions will take precedence.</p>
        <p>If you are an existing Everyday Rewards member, you are able to link your existing Everyday Rewards
          membership to your Everyday Rewards Plus Card account and your existing Everyday Rewards points balance will
          be reflected in your new Everyday Rewards Plus Card account.</p>
        <p>If you do not wish to link your existing Everyday Rewards membership to your Everyday Rewards Plus Card
          account, you will need to provide a separate email address (which is different from the email address you are
          using for your existing Everyday Rewards account) in order to activate your Everyday Rewards Plus Card and
          open a new Everyday Rewards account. </p>
        <p>By activating your Everyday Rewards Plus Card you will, unless you are already an Everyday Rewards member and
          you link your existing Everyday Rewards account to your Everyday Rewards Plus Card account, also be enrolled
          in the Everyday Rewards Program.</p>
      </div>
    </div>

    <div>
      <div>
        <h3 class="bold">Important things to note:</h3>
        <h4>Who is eligible for a primary Everyday Rewards Plus Card?</h4>
        <ul>
          <li>If you are a full-time, part-time or casual team member (employee) of Woolworths New Zealand Limited or
            any of its majority owned subsidiaries in New Zealand, or an employee of Woolworths Group Limited or any of
            its majority owned subsidiaries in Australia (collectively, Woolworths Group), you are eligible for People &
            Culture to provide you with a primary Everyday Rewards Plus Card.
          </li>
          <li>Certain employees of particular Woolworths Group partner businesses may also be eligible to apply for a
            primary Everyday Rewards Plus Card, as notified to those employees by Woolworths Group or their employer
            from time to time.
          </li>
        </ul>
        <p>Woolworths Group partner businesses whose employees are eligible for a primary Everyday Rewards Plus Card are
          referred to in these Terms and Conditions as <span class="bold">“Eligible Partners”</span>.</p>

        <h4>If I am a primary Everyday Rewards Plus cardholder, can I apply for a secondary Everyday Rewards Plus
          Card?</h4>
        <ul>
          <li>If you are a full-time or part-time team member (employee) of Woolworths Group, you can apply for a
            secondary Everyday Rewards Plus Card. You can nominate as your secondary Everyday Rewards Plus cardholder
            one member of your (the primary cardholder's) immediate family who must live at the same address as the
            primary Everyday Rewards Plus cardholder e.g. a spouse, de facto partner, same sex de facto partner, parent,
            child or sibling. If your secondary cardholder is under the age of 18, you must first obtain their parent or
            guardian’s consent to join.
          </li>
          <li>If you are a primary Everyday Rewards Plus cardholder who is eligible to apply for a secondary Everyday
            Rewards Plus Card, you agree:
            <ul>
              <li>To only apply for and activate the secondary Everyday Rewards Plus Card for your secondary cardholder
                with that person’s consent and
              </li>
              <li>To apply for and activate the secondary Every Rewards Plus Card for your secondary cardholder only
                after they have agreed to these Terms and Conditions and
              </li>
              <li>You have advised them that their personal information will be disclosed to Woolworths Group Limited in
                order to verify and administer eligibility for the Everyday Rewards Plus Card program and treated in
                accordance with <a href="https://www.woolworthsgroup.com.au/privacy" target="_blank">Woolworths’ Privacy
                  Policy</a>, and
              </li>
              <li>You have advised them that by activating the secondary Everyday Rewards Plus Card they will also be
                enrolled in the Everyday Rewards Program (unless they are already an Everyday Rewards member), which is
                subject to the Everyday Rewards Program Terms and Conditions, and Woolworths New Zealand Privacy Policy.
              </li>
            </ul>
          </li>
          <li>The eligibility of primary Everyday Rewards Plus cardholders who are employees of Eligible Partners to
            apply for a secondary Everyday Rewards Plus Card will be as notified to those employees by Woolworths Group
            or their employer from time to time.
          </li>
          <li>Casual team members (employees), whether of Woolworths Group or any other Eligible Partner, are not
            eligible for a secondary Everyday Rewards Plus Card.
          </li>
          <li>The secondary Everyday Rewards Plus Card will be issued in the nominated family member's name. The
            secondary cardholder will cease to be eligible if they no longer reside at the same primary address as the
            primary Everyday Rewards Plus cardholder.
          </li>
          <li>Each primary and secondary cardholder will have separate Everyday Rewards Plus accounts and cards relating
            to their individual Everyday Rewards Plus Card.
          </li>
        </ul>

        <h4>Only you may use your Everyday Rewards Plus Card:</h4>
        <ul>
          <li>Primary and secondary cardholders are the only individuals who are allowed to use or otherwise receive the
            offers associated with the Everyday Rewards Plus Card program. Everyday Rewards Plus Cards can only be used
            by the person whose name appears on the card.
          </li>
          <li>The Everyday Rewards Plus Card account and card must not be used to obtain a discount or other benefit for
            anyone other than the cardholder, and may not be used to purchase goods for resale. Proof of identification
            may be requested at point of sale. If identification is not provided, the discount may not be applied.
          </li>
          <li>Cards should not be “shared” either in a physical, copied or digital format, i.e. cardholders should not
            allow another person to use their Everyday Rewards Plus Card. Misuse of the Everyday Rewards Plus Card may
            also result in the card being confiscated and/or one or both of the cardholders no longer being eligible to
            receive Everyday Rewards Plus Card offers. Misuse of the Everyday Rewards Plus Card may also result in
            disciplinary action being taken against the primary cardholder (i.e. the team member) by their employer,
            which may include termination of the team member’s employment. The primary and any secondary Everyday
            Rewards Plus Cards must be returned to Woolworths Group or, if directed, destroyed by the cardholder, when
            the team member ends employment with Woolworths Group or the Eligible Partner.
          </li>
        </ul>

        <h4>What communications will I receive from Everyday Rewards about the Everyday Rewards Plus Card and how can I
          opt-out of Everyday Rewards Plus Card communications?</h4>
        <p>As an Everyday Rewards Plus Card cardholder you will receive:</p>
        <ul>
          <li>Communications (including marketing and promotional messages) sent to you in your capacity as an Everyday
            Rewards member. For more details about communications you receive as an Everyday Rewards member, please see
            the Everyday Rewards Terms and Conditions here: <a
              href="http://www.everydayrewards.co.nz/terms-and-conditions" target="_blank">www.everydayrewards.co.nz/terms-and-conditions</a>;
            and
          </li>
          <li>marketing and promotional messages exclusive to Everyday Rewards Plus Card cardholders, and which
            accordingly are sent to you in your capacity as an Everyday Rewards Plus Card cardholder.
          </li>
        </ul>
        <p>There are also some messages that we must be able to send you even if you have opted-out. These include, for
          example:</p>

        <ul>
          <li>Messages relating to your Everyday Rewards or Everyday Rewards Plus Card account (such as changes to your
            account, important information relating to products and services you have purchased (like health and safety
            recall notices), forgotten passwords, updates to our T&Cs and Privacy Policy); and
          </li>
          <li>If you are a Woolworths Group team member, messages we send you as your employer (such as messages about
            team benefits that we send exclusively to all Woolworths Group employees (not just Everyday Rewards Plus
            Card primary cardholders)).
          </li>
        </ul>

        <h4>Can my Everyday Rewards Plus Card be cancelled or terminated?</h4>
        <p>We reserve the right at any time without notice to:</p>
        <ul>
          <li>decline to issue, withdraw or cancel any Everyday Rewards Plus Cards or offers;</li>
          <li>reverse any Everyday Rewards Plus Card offer benefits; and</li>
          <li>terminate or suspend your Everyday Rewards Plus Card account.</li>
        </ul>
        <p>Grounds for any of the above include:</p>
        <ul>
          <li>the termination or suspension of your Everyday Rewards account;</li>
          <li>if the primary cardholder’s account has been terminated (including when the primary cardholder’s
            employment with Woolworths Group, or with the Eligible Partner, ends); and
          </li>
          <li>if the primary or secondary cardholder has done anything that is contrary to these Terms and Conditions.
          </li>
        </ul>
        <p>If your Everyday Rewards Plus Card account is terminated, you will no longer receive the offers associated
          with the Everyday Rewards Plus Card program. Any physical Everyday Rewards Plus Card relating to the
          terminated account or accounts must also be returned to Woolworths Group or, if directed, destroyed by the
          relevant cardholder.</p>
        <p>If your Everyday Rewards Plus Card account is terminated, you will, unless your Everyday Rewards membership
          has also separately been terminated, remain an Everyday Rewards member and the Everyday Rewards Terms and
          Conditions will continue to apply to your Everyday Rewards membership</p>
        <p>If you cancel your Everyday Rewards membership that is linked to your Everyday Rewards Plus Card account,
          your Everyday Rewards Plus Card account will also be terminated.</p>

        <h4>Can these Terms & Conditions be changed or the Everyday Rewards Plus Card program terminated?</h4>
        <p>Yes. Woolworths Group reserves the right to change or suspend these Terms & Conditions or to terminate the
          Everyday Rewards Plus Card program at any time.</p>
        <p>We will notify both primary and secondary cardholders of any substantive changes to these Terms & Conditions.
          Continuing to use your Everyday Rewards Plus Card after the effective date of the changes to these Terms &
          Conditions will be deemed as acceptance by you of the Terms and Conditions as so amended.</p>

        <h4>What happens if I leave the Woolworths Group or the Eligible Partner? Will the Everyday Rewards Plus Card be
          cancelled?</h4>
        <p>Yes, if you leave the employment of the Woolworths Group or Eligible Partner, your Everyday Rewards Plus Card
          and any secondary Everyday Rewards Plus Cards will be cancelled. You and the former secondary Everyday Rewards
          Plus cardholder will be issued with separate Everyday Rewards customer cards. All Everyday Rewards points
          accumulated by you will be transferred to the Everyday Rewards customer cards.</p>

        <h4>How will Everyday Rewards Plus be collecting, using and disclosing my personal information?</h4>
        <p>For details about how your personal information is dealt with please see the Woolworths NZ Privacy Policy,
          available via the Everyday Rewards website at <a href="http://www.everydayrewards.co.nz/privacy-policy"
                                                           target="_blank">www.everydayrewards.co.nz/privacy-policy</a>.
          If you are an Everyday Rewards Plus cardholder who is an employee of an Eligible Partner, please be aware that
          Woolworths Group may disclose personal information in relation to you and your use of your Everyday Rewards
          Plus Card to your employer, in the event that Woolworths Group has reasonable grounds to suspect misuse of
          your Everyday Rewards Plus Card. Woolworths Group will only disclose such information as is reasonably
          required for investigation of the suspected misuse.</p>
      </div>
    </div>

  </div>
  <!-- NZ - end -->
  <div *ngIf="purpose === 'activation' || purpose === 'selfserve'" class="terms-checkbox">
    <mat-checkbox [checked]="termsCheck" (change)="toggleTermsCheck($event.checked)">
      Yes, I have read and accept the Terms and Conditions.
    </mat-checkbox>
  </div>
  <div class="button-container" *ngIf="purpose === 'activation'">
    <button mat-raised-button color="accent" [disabled]="!termsCheck" (click)="termsClick.emit()">
      Continue
    </button>
  </div>
  <div class="button-container" *ngIf="purpose === 'selfserve'">
    <button mat-raised-button (click)="termsClick.emit('cancel')">
      Cancel
    </button>
    <button mat-raised-button color="accent" [disabled]="!termsCheck" (click)="termsClick.emit('continue')">
      Continue
    </button>
  </div>
</div>
<div class="container" *ngIf="country==='OT'">
  <!-- OT - start -->
  <div class="tc-wrapper">
    <div class="">
      <div class="">
        <h1>Terms and conditions</h1>
        <h2>Everyday Rewards Plus Card - Asia team members<br> &nbsp;</h2>
      </div>
    </div>
    <div class="">
      <div class="">
        <p><span class="bold">It is your responsibility to ensure that your Everyday Rewards Plus Card is used in line with these
          Everyday Rewards Plus Card Terms &amp; Conditions as well as the Everyday Rewards Program Terms
          &amp; Conditions which can be found at</span> <a href="https://www.woolworthsrewards.com.au/terms.html"
                                                        target="_blank"><u>everdayrewards.com.au/terms</u></a>.
        </p>
        <p>It is important that you read these Terms and Conditions. In addition, there are some specific terms we
          wanted to make you aware of. These are set out below.&nbsp;</p>
        <p>These terms and conditions apply in addition to the Everyday Rewards Terms and Conditions.</p>
        <p>It is important that you read these terms and conditions and the Everyday Rewards Terms and Conditions
          together.</p>
        <p>We can also, at any time without notice:</p>
        <ul>
          <li>
            <p>decline to issue, withdraw or cancel your Everyday Rewards Plus Cards or offers;</p>
          </li>
          <li>
            <p>reverse any related offer benefits; and</p>
          </li>
          <li>
            <p>terminate or suspend your Everyday Rewards Plus Card account.&nbsp;</p>
          </li>
        </ul>
        <p>We may also change or suspend these terms and conditions or the Everyday Rewards Plus Card Program at any
          time. However, if these changes are substantive, we’ll give you notice ahead of time.&nbsp;</p>
        <p>These Everyday Rewards Plus Card Terms &amp; Conditions apply to all Everyday Rewards Plus cardholders
          (whether you are the primary or the secondary cardholder) in addition to the Everyday Rewards Program
          Terms &amp; Conditions. To the extent of any inconsistency, these Everyday Rewards Plus Card Terms &amp;
          Conditions will take precedence.</p>
        <p>If you are an existing Everyday Rewards Member, you are able to link your existing Everyday Rewards
          membership to your Everyday Rewards Plus Card account and your existing Everyday Rewards points balance
          will be reflected in your new Everyday Rewards Plus Card account.</p>
        <p>If you do not wish to link your existing Everyday Rewards membership to your Everyday Rewards Plus Card
          account, you will need to provide a separate email address (which is different from the email address
          you are using for your existing Everyday Rewards account) in order to activate your Everyday Rewards
          Plus Card and open a new Everyday Rewards account.</p>
        <p>By activating your Everyday Rewards Plus Card you will, unless you are already an Everyday Rewards member
          and you link your existing Everyday Rewards account to your Everyday Rewards Plus Card account, also be
          enrolled in the Everyday Rewards Program.</p>
        <p>There are two supported versions of the digital Everyday Rewards Plus Card: Apple Wallet and Google Pay.
          Use of any other card storage apps, such as StoCard, is not permitted.</p>
        <p>You can also download the Everyday Rewards app and load your Everyday Rewards Plus Card. This will allow
          you to get in app access to your offers and boosters, including getting access to app exclusive offers
          and boosters.</p>
        <p class="bold">Important things to note:</p>
      </div>
    </div>
    <div class="">
      <div class="">
        <h3>Who is eligible for a primary Everyday Rewards Plus Card?</h3>
        <ul>
          <li>If you are a full-time, part-time or casual team member (employee) of Woolworths Group Limited or
            any of its majority owned subsidiaries (collectively, Woolworths Group), you are eligible to apply
            for a primary Everyday Rewards Plus Card.
          </li>
          <li>
            <p>If you are a full-time, part-time or casual team member (employee) of Endeavour Group Limited or
              any of its majority owned subsidiaries&nbsp; (collectively, Endeavour Group),&nbsp; you are
              eligible to apply for a primary Everyday Rewards Plus Card.</p>
          </li>
          <li>
            <p>Certain employees of particular Woolworths Group partner businesses may also be eligible to apply
              for a primary Everyday Rewards Plus Card, as notified to those employees by Woolworths Group or
              their employer from time to time.</p>
          </li>
          <li>
            <p>Endeavour Group and Woolworths Group partner businesses whose employees are eligible for a
              primary Everyday Rewards Plus Card are referred to in these Terms and Conditions as “Eligible
              Partners”.</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="">
      <div class="">
        <h3>If I am a primary Everyday Rewards Plus cardholder, can I apply for a secondary Everyday Rewards Plus
          Card?</h3>
        <ul>
          <li>
            <p>If you are a full-time or part-time team member (employee) of Woolworths Group or Endeavour
              Group, you can apply for a secondary Everyday Rewards Plus Card. You can nominate as your
              secondary Everyday Rewards Plus cardholder one member of your (the primary cardholder's)
              immediate family who must live at the same address as the primary Everyday Rewards Plus
              cardholder e.g. a spouse, de facto partner, parent, child or sibling. If your secondary
              cardholder is under the age of 18, you must first obtain their parent or guardian’s consent to
              join.&nbsp;</p>
          </li>
          <li>
            <p>If you are a primary Everyday Rewards Plus cardholder who is eligible to apply for a secondary
              Everyday Rewards Plus Card, you agree to only apply for and activate the secondary Everyday
              Rewards Plus Card for your secondary cardholder with that person’s consent and only after they
              have agreed to these Terms and Conditions and you have advised them that their personal
              information will be disclosed to Woolworths Group Limited and treated in accordance with <a
                href="https://www.woolworthsgroup.com.au/privacy" target="_blank">Woolworths’ Group Privacy Policy</a>.&nbsp;
            </p>
          </li>
          <li>
            <p>The eligibility of primary Everyday Rewards Plus cardholders who are employees of Eligible
              Partners other than Endeavour Group, to apply for a secondary Everyday Rewards Plus Card will be
              notified to those employees by Woolworths Group or their employer from time to time.</p>
          </li>
          <li>
            <p>Casual team members (employees), whether of Woolworths Group, Endeavour Group or any other
              Eligible Partner, are not eligible for a secondary Everyday Rewards Plus Card.&nbsp;</p>
          </li>
          <li>
            <p>The secondary Everyday Rewards Plus Card will be issued in the nominated family member's name.
              The secondary cardholder will cease to be eligible if they no longer reside at the same primary
              address as the primary Everyday Rewards Plus cardholder.</p>
          </li>
          <li>
            <p>Each primary and secondary cardholder will have a separate Everyday Rewards account and card
              relating to their individual Everyday Rewards Plus Card. </p>
          </li>
        </ul>
      </div>
    </div>
    <div class="">
      <div class="">
        <h3>Only you may use your Everyday Rewards Plus Card:</h3>
        <ul>
          <li>
            <p>Primary and secondary cardholders are the only individuals who are allowed to use or otherwise
              receive the offers associated with the Everyday Rewards Plus Card program. Everyday Rewards Plus
              Cards can only be used by the person whose name appears on the card.</p>
          </li>
          <li>
            <p>The Everyday Rewards Plus Card account and card must not be used to obtain a discount or other
              benefit for anyone other than the cardholder, and may not be used to purchase goods for resale.
              Proof of identification may be requested at the point of sale. If identification is not
              provided, the discount may not be applied.</p>
          </li>
        </ul>
        <ul>
          <li>
            <p>Cards should not be “shared” either in a physical, copied or digital format, i.e. cardholders
              should not allow another person to use their Everyday Rewards Plus Card. Misuse of the Everyday
              Rewards Plus Card may also result in the card being confiscated and/or one or both of the
              cardholders no longer being eligible to receive Everyday Rewards Plus Card offers. Misuse of the
              Everyday Rewards Plus Card may also result in disciplinary action being taken against the
              primary cardholder (i.e. the team member) by their employer, which may include termination of
              the team member’s employment. The primary and any secondary Everyday Rewards Plus Cards must be
              returned to Woolworths Group or, if directed, destroyed by the cardholder when the team member
              ends employment with Woolworths Group or the Eligible Partner.</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="">
      <div class="">
        <h3>What offers can I get as an Everyday Rewards Plus Card cardholder?</h3>
        <p>The Everyday Rewards Plus Card entitles the cardholder to the below offers:</p>
        <ul>
          <li>
            <p>5% off at Woolworths Supermarkets and Woolworths Metro (excluding Ampol Woolworths Metro), with
              an extra 5% off selected Woolworths FoodCo brands (in store only). For details of Woolworths
              FoodCo products that are included in the extra 5% discount offer, please <a
                href="https://www.woolworthsrewards.com.au/content/dam/wowRewards/wowPeople/docs/Selected_Woolworths_FoodCo_Brands-5%25_off_in-store_only.pdf"
                target="_blank">click here</a>.</p>
          </li>
          <li>
            <p>5% off&nbsp; at BWS (excluding NT), plus an extra 5% off Pinnacle Wines (excluding NT; in-store
              only). Look for an ‘E’ on tickets and ‘bottled by Pinnacle drinks’ on the back label. Discount
              does not apply to liquor items in the Northern Territory, so as to ensure compliance with the NT
              Government’s minimum unit price for alcohol (minimum floor price). For details of Pinnacle Drink
              products that are included in the extra 5% discount offer (in store only), <a
                href="https://www.woolworthsrewards.com.au/content/dam/wowRewards/wowPeople/docs/Pinnacle_Wines.pdf"
                target="_blank">click here</a>.&nbsp;</p>
          </li>
          <li>
            <p>10% off at BIG W in-store and online, excluding BIG W Photos online, Apple products, gaming
              consoles, lay-bys, rainchecks, any gift cards (including iTunes), mobile recharge, travel cards,
              tickets, BIG W eBay, pre-orders, lay-by fees and BIG W products purchased from Everyday Market
              from Woolworths. Additional 10% discount at BIG W on apparel applies to&nbsp; men’s, women’s,
              kids’ and baby apparel, including swimwear, beachwear, footwear and schoolwear (total 20%
              discount) but excluding accessories (such as belts, hats, scarves, gloves, caps and ties),
              underwear, socks and sleepwear (standard 10% discount applies), and any BIG W apparel products
              purchased from Everyday Market from Woolworths or as lay-bys, pre-orders or rainchecks (no
              discount applies). For BIG W online only, when a product which is excluded from the 10% discount
              offer is added to the shopping cart (eg: gaming console), the 10% discount offer will NOT apply
              to the entire shopping cart, even if it includes products to which the 10% discount offer would
              otherwise apply. So that you receive the 10% discount on eligible products when shopping online,
              you will need to purchase products which are excluded from the 10% team discount offer in a
              separate online transaction from products which are eligible for the 10% discount offer.</p>
          </li>
          <li>
            <p>4c per litre off the pump price on fuel purchases of up to 150 litres per transaction at
              participating Ampol or Caltex Woolworths/EG (Operated by EG Australia) fuel outlets. Discounts
              do not apply to any AmpolCard or StarCard purchases. To find out more about the fuel savings
              offer, Terms and Conditions and details of participating sites, <a
                href="https://www.woolworths.com.au/shop/discover/petrol?name=petrol-offer-8&amp;cardId=4854"
                target="_blank">click here</a>.</p>
          </li>
        </ul>
        <p><span class="bold">General Exclusions:</span> The Everyday Rewards Plus Card does not entitle the cardholder to discounts on
          any products sold on Everyday Market from Woolworths. Your Team Benefits discount offers may not be
          applied to a selection of items based on legislative requirements and/or divisional policies (eg tobacco
          and gift cards). Your Team Benefits discount offers are also not available in conjunction with any other
          discount offers, except if otherwise stated in the particular offer T&amp;Cs.</p>
      </div>
    </div>
    <div class="">
      <div class="">
        <h3>What communications will I receive from Everyday Rewards about the Everyday Rewards Plus Card and how
          can I opt-out of Everyday Rewards Plus Card communications?</h3>
        <p>As an Everyday Rewards Plus Card cardholder you will receive:</p>
        <ul>
          <li>
            <p>communications (including marketing and promotional messages) sent to you in your capacity as an
              Everyday Rewards member. For more details about communications you receive as an Everyday
              Rewards member, please see the Everyday Rewards Terms and Conditions here:<a
                href="https://www.woolworthsrewards.com.au/terms.html">
                https://www.everydayrewards.com.au/terms.html</a>; and</p>
          </li>
          <li>
            <p>marketing and promotional messages exclusive to Everyday Rewards Plus Card cardholders, and which
              accordingly are sent to you in your capacity as an Everyday Rewards Plus Card cardholder.</p>
          </li>
        </ul>
        <p>Importantly, opting out of:</p>
        <ul>
          <li>
            <p>the Everyday Rewards Plus Offers (Boosters) preference in your Everyday Rewards account or via
              the unsubscribe facility in messages we send you will not opt you out of receiving messages from
              Everyday Rewards in relation to other Everyday Rewards preferences categories (eg Woolworths
              Supermarkets); and</p>
          </li>
          <li>
            <p>other Everyday Rewards preferences categories (eg Woolworths Supermarkets) will not unsubscribe
              you from Everyday Rewards Plus promotional messages (including any Everyday Rewards Plus
              promotional messages in relation to Woolworths Supermarkets).</p>
          </li>
        </ul>
        <p>There are also some messages that we must be able to send you even if you have opted-out. These include,
          for example:</p>
        <ul>
          <li>
            <p>messages relating to your Everyday Rewards or Everyday Rewards Plus Card account (such as changes
              to your account, important information relating to products and services you have purchased
              (like health and safety recall notices), forgotten passwords, updates to our T&amp;Cs and
              Privacy Policy); and</p>
          </li>
          <li>
            <p>If you are a Woolworths Group Team Member, messages we send you as your Employer (such as
              messages about Team Benefits that we send exclusively to all Woolworths Group Employees (not
              just Everyday Rewards Plus Card primary cardholders).</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="">
      <div class="">
        <h3>Can my Everyday Rewards Plus Card be cancelled or terminated?</h3>
        <p>We reserve the right at any time without notice to:</p>
        <ul>
          <li>
            <p>decline to issue, withdraw or cancel any Everyday Rewards Plus Cards or offers;</p>
          </li>
          <li>
            <p>reverse any Everyday Rewards Plus Card offer benefits; and</p>
          </li>
          <li>
            <p>terminate or suspend your Everyday Rewards Plus Card account.</p>
          </li>
        </ul>
        <p>Grounds for any of the above include:</p>
        <ul>
          <li>
            <p>the termination or suspension of your Everyday Rewards account;</p>
          </li>
          <li>
            <p>if the primary cardholder’s account has been terminated (including when the primary cardholder’s
              employment with Woolworths Group, or with the Eligible Partner, ends); and</p>
          </li>
          <li>
            <p>if the primary or secondary cardholder has done anything that is contrary to these Terms and
              Conditions.</p>
          </li>
        </ul>
        <p>If your Everyday Rewards Plus Card account is terminated, you will no longer receive the offers
          associated with the Everyday Rewards Plus Card program. Any physical Everyday Rewards Plus Card relating
          to the terminated account or accounts must also be returned to Woolworths Group or, if directed,
          destroyed by the relevant cardholder.</p>
        <p>If your Everyday Rewards Plus Card account is terminated, you will, unless your Everyday Rewards
          membership has also separately been terminated, remain an Everyday Rewards member and the Everyday
          Rewards Terms and Conditions will continue to apply to your Everyday Rewards membership.</p>
        <p>If you cancel your Everyday Rewards membership that is linked to your Everyday Rewards Plus Card account,
          your Everyday Rewards Plus Card account will also be terminated.</p>
      </div>
    </div>
    <div class="">
      <div class="">
        <h3>Can these Terms &amp; Conditions be changed or the Everyday Rewards Plus Card program terminated?</h3>
        <p>Yes. Woolworths Group Limited reserves the right to change or suspend these Terms &amp; Conditions or to
          terminate the Everyday Rewards Plus Card program at any time.</p>
        <p>We will notify both primary and secondary cardholders of any substantive changes to these Terms &amp;
          Conditions, for example by publishing a banner notification on everydayrewards.com.au/pluscard/#/toc.
          Continuing to use your Everyday Rewards Plus Card after the effective date of the changes to these Terms
          &amp; Conditions will be deemed as acceptance by you of the Terms and Conditions as so amended.</p>
      </div>
    </div>
    <div class="">
      <div class="">
        <h3>What happens if I leave the Woolworths Group or the Eligible Partner? Will the Everyday Rewards Plus
          Card be cancelled?</h3>
        <p>Yes, if you leave the employment of the Woolworths Group or Eligible Partner, your Everyday Rewards Plus
          Card and any secondary Everyday Rewards Plus Cards will be cancelled. You and the former secondary
          Everyday Rewards Plus cardholder will be issued with separate Everyday Rewards customer cards. All
          Everyday Rewards dollars and Qantas Frequent Flyer Points accumulated by you will be transferred to the
          Everyday Rewards customer cards. The Everyday Rewards team will send out the Everyday Rewards customer
          card to the address stated in your Everyday Rewards account.</p>
      </div>
    </div>
    <div class="">
      <div class="">
        <h3>How will Everyday Rewards Plus be collecting, using and disclosing my personal information?</h3>
        <p>For details about how your personal information is dealt with please see the Everyday Rewards Privacy
          Collection Notice at <a href="https://www.woolworthsrewards.com.au/privacy.html" target="_blank"
          >everydayrewards.com.au/privacy</a>. If you are an Everyday Rewards
          Plus
          cardholder who is an employee of an Eligible Partner, please be aware that Woolworths Group may disclose
          personal information in relation to you and your use of your Everyday Rewards Plus Card to your
          employer, in the event that Woolworths Group has reasonable grounds to suspect misuse of your Everyday
          Rewards Plus Card. Woolworths Group will only disclose such information as is reasonably required for
          investigation of the suspected misuse.&nbsp;&nbsp;</p>
      </div>
    </div>
  </div>
  <!-- OT - end -->
  <div *ngIf="purpose === 'activation' || purpose === 'selfserve'" class="terms-checkbox">
    <mat-checkbox [checked]="termsCheck" (change)="toggleTermsCheck($event.checked)">
      Yes, I have read and accept the Terms and Conditions.
    </mat-checkbox>
  </div>
  <div class="button-container" *ngIf="purpose === 'activation'">
    <button mat-raised-button color="accent" [disabled]="!termsCheck" (click)="termsClick.emit()">
      Continue
    </button>
  </div>
  <div class="button-container" *ngIf="purpose === 'selfserve'">
    <button mat-raised-button (click)="termsClick.emit('cancel')">
      Cancel
    </button>
    <button mat-raised-button color="accent" [disabled]="!termsCheck" (click)="termsClick.emit('continue')">
      Continue
    </button>
  </div>
</div>
